// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__k6eyc","sm":"Avatar_sm__s8zt7","md":"Avatar_md__idwBn","lg":"Avatar_lg__y5tGo","img":"Avatar_img__gZaM1","initials":"Avatar_initials__4ctWb"};